export default {
  "language": "ar",
  "message":
    {
      "title": "حاسبة مكافأة الإسكان ذات الدخل المختلط",
      "zoningDistrict": "حدد منطقة تقسيم المناطق",
      "affordabilityLevel": "حدد مستوى القدرة على تحمل التكاليف",
      "allThatApply": "حدد كل ما ينطبق.",
      "springGardenS": "هل يقع المشروع جنوب شارع سبرينج جاردن",
      "yes": "نعم",
      "no": "لا",
      "affordability": {
        "lowIncome": "دخل منخفض",
        "moderateIncome": "دخل معتدل",
      },
      "lotAreaSqft": "أدخل مساحة اللوت بالقدم المربع",
      "buildingHeight": "أدخل ارتفاع المبنى",
      "totalUnits": "عدد الوحدات المقترح بالمشروع:",
      "unitsEarnedLow": "الوحدات الإضافية المكتسبة (الدخل المنخفض):",
      "unitsEarnedMod": "الوحدات الإضافية المكتسبة (الدخل المتوسط):",
      "greenRoofBonus": "عدد وحدات مكافأة السقف الأخضر:",
      "modIncomePayment": "الدفعة المقدرة للدخل المعتدل:",
      "lowIncomePayment": "الدفعة المقدرة ذات الدخل المنخفض:",
      "requiredAffordableUnits": "الوحدات المطلوبة بأسعار معقولة: «وحدات MIHB المطلوبة بأسعار معقولة",
      "requiredMinAffordableUnits": "الوحدات المطلوبة/الدقيقة بأسعار معقولة:",
      "totalRequiredAffordabilityUnits": "إجمالي الوحدات المطلوبة بأسعار معقولة:",
      "additionalFar": "ضريبة القيمة المضافة الإضافية المكتسبة:",
      "totalFar": "إجمالي FAR:",
      "totalFloor": "إجمالي مساحة الطابق المسموح بها:",
      "overlay": {
        "fithDistrict": "يقع هذا المشروع ضمن منطقة تراكب المنطقة الخامسة (/VDO).",
        "greenRoof": "سيحصل هذا المشروع على مكافأة السقف الأخضر.",
        "minMixed": "يقع هذا المشروع ضمن تراكب الأحياء ذات الدخل المختلط /MIN. '،",
        "todDevelopement": "يقع هذا المشروع ضمن تراكب التطوير الموجه للعبور /TOD.",
      },
      "sFHA": [
        "منطقة خطر الفيضانات الخاصة",
      ],
      "numberOfDwellingUnits": "عدد الوحدات السكنية المسموح بها تحت التقسيم الأساسي:",
      "about": "حول",
      "aboutTitle": "حول مكافأة الإسكان ذات الدخل المختلط",
      "aboutSubTitle": "كيفية استخدام الآلة الحاسبة",
      "paragraphOne": "مكافأة الإسكان ذات الدخل المختلط مخصصة للمطورين الذين يضيفون مساكن بأسعار معقولة لمشاريعهم أو يدفعون إلى صندوق يدعم الإسكان الميسور التكلفة. في المقابل، يحصل التطوير على المزيد من مساحة الطابق «الأيمن» والارتفاع و/أو الوحدات السكنية. يمكن للمطورين الاختيار من بين مستويين من المكافآت. مستوى الدخل المعتدل هو مكافأة أصغر، ولكن لديه معايير أقل صرامة للقدرة على تحمل التكاليف أو مبلغ دفع أقل. يعد مستوى الدخل المنخفض مكافأة أكبر، ولكن لديه معايير أكثر صرامة للقدرة على تحمل التكاليف أو مبلغ دفع أعلى.",
      "paragraphTwo": {
        "text": "تُستخدم حاسبة مكافأة الإسكان ذات الدخل المختلط لتقدير ما يلي بدقة:",
        "bullets": [
          "إجمالي عدد الوحدات المسموح بها.",
          "إجمالي عدد الوحدات ذات الأسعار المعقولة التي سيُطلب منك تقديمها.",
          "الرسوم البديلة التي يجب دفعها مقابل التطوير الذي يستخدم مكافأة الإسكان ذات الدخل المختلط.",
        ],
      },
      "paragraphThree": {
        "text": "للبدء، حدد منطقة تقسيم المناطق الأساسية للعقار وأدخل منطقة القطعة الخاصة به. يجب عليك أيضًا تحديد أي مناطق تراكب قابلة للتطبيق. يمكنك استخدام",
        "link": {
          "text": "أطلس",
          "p": {
            "url": "https://atlas.phila.gov/",
          },
        },
        "continuation": "للعثور على هذه المعلومات.",
      },
      "FinalConfirmation": "تُستخدم هذه الآلة الحاسبة للتخطيط المفاهيمي للمشروع. عندما يكون هناك تعارض بين الآلة الحاسبة وقانون تقسيم فيلادلفيا، فإن قانون تقسيم فيلادلفيا هو الذي يحكم. سيتم إجراء التأكيد النهائي للوحدات، والعدد المطلوب من الوحدات ذات الأسعار المعقولة، و/أو الرسوم البديلة من قبل موظفي لجنة تخطيط مدينة فيلادلفيا أثناء مراجعة تصريح تقسيم المناطق. ",
      "resources": "الموارد",
      "code1": {
        "link": {
          "text": "كود فيلادلفيا - 14-702 (7) - مكافأة الإسكان ذات الدخل المختلط",
          "p": {
            "url": "https://codelibrary.amlegal.com/codes/philadelphia/latest/philadelphia_pa/0-0-0-293117",
          },
        },
      },
      "code2": {
        "link": {
          "text": "كود فيلادلفيا - 14-533 - منطقة تراكب الجوار ذات الدخل المختلط",
          "p": {
            "url": "https://codelibrary.amlegal.com/codes/philadelphia/latest/philadelphia_pa/0-0-0-291906",
          },
        },
      },
      "facts": {
        "link": {
          "text": "صحائف وقائع مكافأة الإسكان ذات الدخل المختلط",
          "p": {
            "url": "https://www.phila.gov/documents/affordable-housing-zoning-bonus-review-application/",
          },
        },
      },
    },
};
